import APIService from '@/api'

export default class APIEvent extends APIService{

    constructor(){
        super('events')
    }

    async getAll() {
        var response = await this.AxiosInstance
            .get(this.ApiUrl)
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    async getTop() {
        var response = await this.AxiosInstance
            .get(this.ApiUrl + "/top", {})
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    create(item, contractId) {
        return this.AxiosInstance.post(this.ApiUrl, item);
    }

    update(item, contractId) {
        return this.AxiosInstance.put(this.ApiUrl, item);
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl, { params: { id: item.ID } });
    }
}


// WEBPACK FOOTER //
// ./src/api/event.js